import { render, staticRenderFns } from "./BusinessDevelopmentServices.vue?vue&type=template&id=38c0f67f&scoped=true"
import script from "./BusinessDevelopmentServices.vue?vue&type=script&lang=js"
export * from "./BusinessDevelopmentServices.vue?vue&type=script&lang=js"
import style0 from "./BusinessDevelopmentServices.vue?vue&type=style&index=0&id=38c0f67f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c0f67f",
  null
  
)

export default component.exports